///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2025
//                                  RXO Inc.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of RXO Inc. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import { bidScacType, mode, rfqStatusTypes } from "../helpers/types";
import getDefaultOptionForOpportunityName from "./getDefaultOptionForOpportunityName";

const undefinedStatus = 0;

export const bidStrategyDefaults = {
  bidStrategy: "",
  shipperTenderStrategy: "",
  expectedLanesPerDay: "",
  goalLanesPerDay: "",
  acceptanceParameters: "",
  strategyNotes: ""
};

export const tlModeDefaults = {
  currentStatus: rfqStatusTypes[0],
  previousStatus: undefinedStatus,
  mode: mode.tl,
  laneCount: "",
  volume: "",
  fuelSurchargeType: null,
  fuelSurchargePeg: "",
  equipmentTypes: null,
  currencyType: null,
  notes: "",
  additionalCurrencies: null,
  strategicQuantile: "",
  rxoFuel: "",
  customerFuel: "",
  customerBranchAndNetworkTimeframeStartDate: null,
  customerBranchAndNetworkTimeframeEndDate: null,
  ...bidStrategyDefaults
};

export const ltlModeDefaults = {
  currentStatus: rfqStatusTypes[0],
  previousStatus: undefinedStatus,
  mode: mode.ltl,
  laneCount: "",
  volume: "",
  ltlFreightClasses: null,
  palletsStackable: null,
  ltlIncumbentCarriers: "",
  ltlPreferredCarriers: "",
  ltlRateReturnFormat: null,
  requiresGuaranteedShipment: null,
  ltlAccessorials: null,
  notes: "",
  additionalCurrencies: null,
  ...bidStrategyDefaults
};

export const imdlModeDefaults = {
  currentStatus: rfqStatusTypes[0],
  previousStatus: undefinedStatus,
  mode: mode.imdl,
  laneCount: "",
  volume: "",
  fuelSurchargeType: null,
  fuelSurchargePeg: "",
  equipmentLengths: null,
  palletCount: "",
  competitors: "",
  notes: "",
  additionalCurrencies: null,
  rxoFuel: "",
  customerFuel: "",
  currencyType: null,
  bidSubmissionType: 0,
  bidLoginDetails: "",
  ...bidStrategyDefaults
};

export const getNewBidDefaults = {
  bidScac: bidScacType[0],
  openDateUTC: null,
  closeDateUTC: null,
  additionalBidRounds: [],
  startDateUTC: null,
  endDateUTC: null,
  awardDateUTC: null,
  strategicStartDateUTC: null,
  strategicEndDateUTC: null,
  strategyDuration: null,
  marginExpectationPercentage: "",
  annualSpend: "",
  maxCargoValue: "",
  shipper: null,
  rfqName: "",
  bidOutputFormat: null,
  files: [],
  modes: [{ ...ltlModeDefaults }],
  mainSalesRepDetails: {
    mainSalesRep: null,
    loading: false,
    noRepErrror: false,
    fetchError: false
  },
  shipperOpsGroup: "",
  shipperOpsGroupOffice: null,
  totalRounds: "",
  bidType: null,
  opportunityId: null,
  shipperOpportunityNames: getDefaultOptionForOpportunityName(),
  salesforceOpportunityId: "",
  previousSalesforceOpportunityId: "",
  locationCode: "",
  foShipperCode: "",
  operationalCenters: null,
  freightOptimizerCodes: null,
  accountOwner: ""
};

export default getNewBidDefaults;
